import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'CustomPageButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

const telemObject = createTelemetryObject({
  actions: {
    saveTextClicked: (page: string) => ({
      ...actionProps,
      page,
      label: 'Save Text Clicked',
      extraInfo: {
        itemType: 'richText',
      },
    }),
  },
});

const { TelemetryProvider: WebsiteEditorRichTextTelemetryProvider, useTelemetry: useWebsiteEditorRichTextTelemetry } = createTelemetry(telemObject);

export { WebsiteEditorRichTextTelemetryProvider, useWebsiteEditorRichTextTelemetry };
